var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlasticicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20_30383)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 82,
    height: 82,
    rx: 41,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 81,
    height: 81,
    rx: 40.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9375 43.3812C51.1688 43.3812 50.5312 42.7437 50.5312 41.975V38.6563C50.5312 37.7751 49.8187 37.0625 48.9375 37.0625H35.0625C34.2937 37.0625 33.6562 36.425 33.6562 35.6562C33.6562 34.8875 34.2937 34.25 35.0625 34.25H48.9375C51.375 34.25 53.3438 36.2376 53.3438 38.6563V41.975C53.3438 42.7437 52.7062 43.3812 51.9375 43.3812Z",
    fill: "url(#paint0_linear_20_30383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.231 40.2125C37.8747 40.2125 37.5185 40.0812 37.2372 39.8L34.0685 36.6312C33.5247 36.0875 33.5247 35.1875 34.0685 34.6437L37.2372 31.475C37.781 30.9312 38.681 30.9312 39.2247 31.475C39.7685 32.0187 39.7685 32.9187 39.2247 33.4624L37.0497 35.6375L39.2247 37.8125C39.7685 38.3562 39.7685 39.2562 39.2247 39.8C38.9435 40.0812 38.5872 40.2125 38.231 40.2125Z",
    fill: "url(#paint1_linear_20_30383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9375 50.7689H38.0625C35.625 50.7689 33.6562 48.7815 33.6562 46.3627V43.0439C33.6562 42.2752 34.2937 41.6377 35.0625 41.6377C35.8312 41.6377 36.4688 42.2752 36.4688 43.0439V46.3627C36.4688 47.244 37.1813 47.9564 38.0625 47.9564H51.9375C52.7062 47.9564 53.3438 48.5939 53.3438 49.3627C53.3438 50.1314 52.7062 50.7689 51.9375 50.7689Z",
    fill: "url(#paint2_linear_20_30383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7687 53.9186C48.4125 53.9186 48.0562 53.7873 47.775 53.506C47.2313 52.9623 47.2313 52.0623 47.775 51.5185L49.95 49.3436L47.775 47.1685C47.2313 46.6248 47.2313 45.7248 47.775 45.181C48.3187 44.6373 49.2187 44.6373 49.7625 45.181L52.9312 48.3498C53.475 48.8935 53.475 49.7935 52.9312 50.3373L49.7625 53.506C49.5 53.7873 49.125 53.9186 48.7687 53.9186Z",
    fill: "url(#paint3_linear_20_30383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 62.6562C32.3813 62.6562 23.3438 53.6187 23.3438 42.5C23.3438 31.3813 32.3813 22.3438 43.5 22.3438C54.6187 22.3438 63.6562 31.3813 63.6562 42.5C63.6562 53.6187 54.6187 62.6562 43.5 62.6562ZM43.5 25.1562C33.9375 25.1562 26.1562 32.9375 26.1562 42.5C26.1562 52.0625 33.9375 59.8438 43.5 59.8438C53.0625 59.8438 60.8438 52.0625 60.8438 42.5C60.8438 32.9375 53.0625 25.1562 43.5 25.1562Z",
    fill: "url(#paint4_linear_20_30383)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20_30383",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20_30383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20_30383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_30383",
    x1: 43.5,
    y1: 34.25,
    x2: 43.5,
    y2: 43.3812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_30383",
    x1: 36.6466,
    y1: 31.0671,
    x2: 36.6466,
    y2: 40.2125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_30383",
    x1: 43.5,
    y1: 41.6377,
    x2: 43.5,
    y2: 50.7689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20_30383",
    x1: 50.3531,
    y1: 44.7732,
    x2: 50.3531,
    y2: 53.9186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20_30383",
    x1: 43.5,
    y1: 22.3437,
    x2: 43.5,
    y2: 62.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticicon);
export default __webpack_public_path__ + "static/media/plasticicon.2ac526321dcc2bb29b6d473291e973e5.svg";
export { ForwardRef as ReactComponent };